import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import LanguageIcon from "@mui/icons-material/Language";
import GppBadIcon from "@mui/icons-material/GppBad";
import PolicyIcon from "@mui/icons-material/Policy";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import LocalPoliceIcon from "@mui/icons-material/LocalPolice";
import ArticleIcon from "@mui/icons-material/Article";
import { useTranslation } from "../context/I18nContext";

type SourceKey =
  | "social_media"
  | "web"
  | "scammers"
  | "sexual_offenders"
  | "videos"
  | "police_photos"
  | "news_and_blogs";

const ICON_MAP: Record<SourceKey, React.ReactNode> = {
  social_media: <PeopleAltIcon />,
  web: <LanguageIcon />,
  scammers: <GppBadIcon />,
  sexual_offenders: <PolicyIcon />,
  videos: <VideoLibraryIcon />,
  police_photos: <LocalPoliceIcon />,
  news_and_blogs: <ArticleIcon />,
};

interface SourceCardProps {
  sourceKey: SourceKey;
}

const SourceCard: React.FC<SourceCardProps> = ({ sourceKey }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box
      sx={{
        bgcolor: "background.default",
        borderRadius: 3,
        p: 3,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 1,
        boxShadow: "0 4px 16px rgba(25,28,30,0.05)",
        border: `1px solid ${theme.palette.divider}`,
        transition: "box-shadow 0.2s ease",
        "&:hover": {
          boxShadow: "0 8px 24px rgba(25,28,30,0.10)",
        },
      }}
    >
      <Box
        sx={{
          color: "primary.main",
          display: "flex",
          alignItems: "center",
          mb: 0.5,
        }}
      >
        {ICON_MAP[sourceKey]}
      </Box>
      <Typography
        variant="subtitle2"
        sx={{
          fontFamily: '"Manrope", sans-serif',
          fontWeight: 700,
          color: "text.primary",
          lineHeight: 1.3,
        }}
      >
        {t(`sources.${sourceKey}.name`)}
      </Typography>
      {/* <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          lineHeight: 1.5,
          fontSize: "0.8rem",
        }}
      >
        {t(`sources.${sourceKey}.description`)}
      </Typography> */}
    </Box>
  );
};

export default SourceCard;
